export default __webpack_public_path__ + "static/bill-curl-bl-d87512266867978786154f7f807db0f8.png";